module.exports = __webpack_public_path__ + "static/img/fc3d0d5ffed7039478ee35225193e8ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s_icon7.jpg
// module id = dGWd
// module chunks = 1